<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-input v-model="inputValue"
                 :name="path"
                 :stack-label="label | capitalize"
                 :type="type"
                 :color="color"
                 :min-rows="minRows"
                 :disable="form.busy || disable"
                 :autofocus="autofocus"
                 :prefix="prefix"
                 @input="onInput"
                 :before="before"
                 :after="after"
                 :placeholder="placeholder"
                 @blur="event => $emit('blur', event)"></q-input>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QInput} from 'quasar-framework'

    export default {
        name: 'VInput',

        mixins,

        props: {
            type: {
                type: String,
                default: 'text'
            },
            minRows: {
                type: Number,
                default: 1
            },
            autofocus: Boolean,
            prefix: String,
            placeholder: String
        },

        components: {
            QInput
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VInput.vue